<template>
  <div>
    <h1>Страница ролей</h1>
    <!-- Таблица администраторов -->
    <AdminTable :admins="admins" @delete-admin="deleteAdmin" />
    <div class="mt-4">
      <button @click="toggleAdminForm" class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded shadow-md transition duration-200">
        Создать нового сотрудника
      </button>
      <button @click="toggleRoleForm" class="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded shadow-md transition duration-200 ml-2">
        Создать новую роль
      </button>
    </div>

    <AdminForm v-if="showAdminForm" @adminCreated="handleAdminCreated" />

    <!-- Форма создания роли -->
    <RoleForm v-if="showRoleForm" @roleCreated="handleRoleCreated" />
  </div>
</template>

<script>
import AdminForm from "@/components/AdminForm.vue";
import AdminTable from "@/components/AdminTable.vue";
import RoleForm from "@/components/RoleForm.vue";
import { getAdmins } from "@/services/userService";
import { deleteApplicationById } from "@/services/verificationService";

export default {
  name: "RolesView",
  components: {
    AdminForm,
    AdminTable,
    RoleForm,
  },
  data() {
    return {
      showAdminForm: false,
      showRoleForm: false,
      admins: [],
    };
  },
  methods: {
    toggleAdminForm() {
      this.showAdminForm = !this.showAdminForm;
      this.showRoleForm = false; // Закрываем форму роли при открытии формы администратора
    },
    toggleRoleForm() {
      this.showRoleForm = !this.showRoleForm;
      this.showAdminForm = false; // Закрываем форму администратора при открытии формы роли
    },
    async fetchAdmins() {
      try {
        const response = await getAdmins();
        this.admins = response.data.admins;
      } catch (error) {
        console.error("Ошибка при получении администраторов:", error);
      }
    },
    handleAdminCreated() {
      this.showAdminForm = false;
      this.fetchAdmins();
    },
    handleRoleCreated() {
      this.showRoleForm = false;
      // Обновите список ролей для AdminForm, если требуется
    },
    async deleteAdmin(adminId) {
      try {
        await deleteApplicationById(adminId);
        this.admins = this.admins.filter(admin => admin.id !== adminId);
      } catch (error) {
        console.error("Ошибка при удалении администратора:", error);
      }
    },
  },
  created() {
    this.fetchAdmins();
  },
};
</script>
